// "use client";
// import Button from "@/components/ui/Button";
// import { useState } from "react";
// import { SuccessIcon } from "@/components/icons";
// import Helper from "@/utils/helper";
// import ErrorCode from "./../../_components/error/ErrorCode";
// export default function Error({
// 	error,
// 	reset,
// }: {
// 	error: Error & { digest?: string };
// 	reset: () => void;
// }) {
// 	const [isSended, setIsSended] = useState(false);
// 	const [loading, setLoading] = useState(false);

// 	const handleSender = async () => {
// 		setLoading(true);
// 		await setTimeout(() => {
// 			setIsSended(true);
// 			setLoading(false);
// 		}, 1500);
// 	};

// 	return (
// 		<div className="minheightBody  flex justify-center items-center flex-col gap-4 text-center">
// 			<h2>Hiện hệ thống đang gặp lỗi vui lòng thử lại</h2>
// 			<div className="flex gap-1 w-full lg:w-[30vw]">
// 				<Button className="flex-1 inline-block text-base" onClick={reset}>
// 					Tải lại
// 				</Button>
// 				<Button
// 					mode="main-outline"
// 					className="flex-1 inline-block text-base"
// 					onClick={handleSender}
// 					loading={loading}>
// 					{isSended ? (
// 						<span className="inline-flex items-center item gap-1 text-sm h-full">
// 							<SuccessIcon className="w-[16px] h-[16px]"></SuccessIcon>
// 							Đã gửi phản hồi
// 						</span>
// 					) : (
// 						"Gửi phản hồi"
// 					)}
// 				</Button>
// 			</div>
// 			{Helper.isDev() && <ErrorCode error={error}></ErrorCode>}
// 		</div>
// 	);
// }
"use client";

import ErrorCustom from "~components/customPages/ErrorCustom";
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // return <ErrorBoundary error={error} reset={reset}></ErrorBoundary>;
  return (
    <>
      <ErrorCustom from="products" error={error} reset={reset} />;
    </>
  );
}
